import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { GlobalRightsContext } from 'providers/GlobalRightsContext';
import { ApplicationFeaturesContext } from 'providers/ApplicationFeaturesContext';
import NotFound from 'components/common/NotFound';
const ResponsibleChangeOfferListContainerAuthorization = ({ children }) => {
    const { bulkResponsibleAssignation } = useContext(ApplicationFeaturesContext);
    const { offerBulkResponsbileAllocation } = useContext(GlobalRightsContext);

    if (!bulkResponsibleAssignation || !offerBulkResponsbileAllocation) return <NotFound title='PageNotFound'></NotFound>;
  
    return children;
  };
  
  ResponsibleChangeOfferListContainerAuthorization.propTypes = {
    children: PropTypes.node.isRequired
  };


  export default ResponsibleChangeOfferListContainerAuthorization;